module.exports = __webpack_public_path__ + "static/media/son.941adaef.png";